const home = {
  // Hero
  hero_badge: 'Turkey\'s Health Tourism Platform',
  hero_title_1: 'Regain Your',
  hero_title_2: 'Health',
  hero_title_3: 'in Turkey',
  hero_subtitle: 'Discover Turkey\'s accredited health institutions for patients coming from abroad. Plan your trip yourself or leave all the organization to an intermediary agency.',
  hero_stat_institutions: 'Accredited Institutions',
  hero_stat_patients: 'Happy Patients',
  hero_stat_doctors: 'Expert Doctors',
  hero_stat_countries: 'Countries',
  hero_accreditation_label: 'Accreditation:',
  hero_search_title: 'Search Treatment',
  hero_step1_label: 'Treatment Type',
  hero_step1_placeholder: 'Type or select treatment...',
  hero_step2_label: 'Organization Preference',
  hero_self_organize: 'I Can Organize the Trip Myself',
  hero_agency_organize: 'Let an Agency Organize My Hospital & Trip',
  hero_step3_agency: 'Intermediary Agency',
  hero_step3_institution: 'Health Institution',
  hero_step3_optional: '(optional)',
  hero_all_agencies: 'See all agencies',
  hero_all_institutions: 'See all institutions',
  hero_city_label: 'City',
  hero_all_cities: 'All Cities',
  hero_search_agencies: 'Explore Agencies',
  hero_search_institutions: 'Explore Health Institutions',
  hero_trust_note: 'All institutions are approved by the Republic of Turkey Ministry of Health',

  // Steps section
  steps_title: '3 Steps to Use the Platform',
  steps_subtitle: 'Finding the right health institution is now much easier',
  step1_number: 'Step 1',
  step1_title: 'Register for Free',
  step1_desc: 'Register on the platform for free and get instant access to all features',
  step2_number: 'Step 2',
  step2_title: 'Browse Institutions',
  step2_desc: 'Compare accredited health institutions, review doctors and services',
  step3_number: 'Step 3',
  step3_title: 'Send Callback Request',
  step3_desc: 'Send a callback request to your chosen institution, they will call you in your language',

  // Treatment areas
  treatment_badge: 'Treatment Areas',
  treatment_title: 'Most Preferred',
  treatment_title_highlight: 'Treatments in Turkey',
  treatment_subtitle: 'Thousands of international patients choose Turkey every year. Discover accredited institutions in the treatment areas below.',
  treatment_view_institutions: 'View Institutions',
  treatment_view_all: 'View All Treatment Areas',

  // Featured institutions
  institutions_title: 'Health',
  institutions_title_highlight: 'Institutions',
  institutions_subtitle: 'Find the most suitable one among approved health institutions',
  institutions_view_all: 'View All Institutions',
  institutions_empty: 'No approved institutions yet.',
  agencies_badge: 'Organization & Travel Services',
  agencies_title: 'Health Tourism',
  agencies_title_highlight: 'Agencies',
  agencies_subtitle: 'Agencies that organize your health service together with your travel, accommodation and tourism needs',
  agencies_view_all: 'View All Agencies',
  agencies_empty_title: 'No Agencies Yet',
  agencies_empty_desc: 'Agencies will be listed soon.',
  agency_label: 'Agency',
  consultation_available: 'Consultation request can be sent',
  service_flight: 'Flight & Transfer',
  service_hotel: 'Hotel Reservation',
  service_tour: 'Tourist Tour',
  service_translation: 'Translation',
  service_vip: 'VIP Welcome',

  // Why us
  why_title: 'Why',
  why_title_highlight: 'Choose Us?',
  why_subtitle: 'Your trusted guide for international patients seeking healthcare in Turkey',
  why_stat_institutions: 'Accredited Institutions',
  why_stat_treatments: 'Treatment Areas',
  why_stat_countries: 'Countries',
  why_stat_satisfaction: 'Patient Satisfaction',
  why_feature1_title: 'Accredited Institutions',
  why_feature1_desc: 'All health institutions on the platform are verified institutions with JCI, ISO or Republic of Turkey Ministry of Health accreditation.',
  why_feature2_title: 'Multilingual Support',
  why_feature2_desc: 'Easily filter institutions that offer communication support in Arabic, English, Russian and more languages.',
  why_feature3_title: 'Detailed Comparison',
  why_feature3_desc: 'Compare institutions side by side based on their services, doctors, locations and patient reviews.',
  why_feature4_title: 'Callback Request',
  why_feature4_desc: 'Send a callback request directly to the institution you like. The institution will call you with their language support.',
  why_feature5_title: 'Affordable Cost',
  why_feature5_desc: 'Get world-class healthcare at 50-70% lower prices compared to Europe and the USA.',
  why_feature6_title: 'Location & Transportation',
  why_feature6_desc: 'Discover institutions in all cities of Turkey, especially Istanbul, Ankara, Izmir and Antalya.',

  // Featured institutions - extra
  inst_approved_badge: 'Approved',
  inst_explore: 'Explore',
  inst_doctor_count: '{{count}} Doctor',
  inst_no_approved: 'No approved institutions yet.',
  agencies_service_badge: 'Health Tourism Agency',
  agencies_consult: 'Consultation request can be sent',
  agencies_explore: 'Explore',

  // Process section
  process_badge: 'Step by Step',
  process_title: 'IVF',
  process_title_highlight: 'Process',
  process_subtitle: 'Learn every stage of IVF treatment in an understandable way',
  process_step_label: 'Step {{num}}',
  process_step1_title: 'Pre-Evaluation',
  process_step1_desc: 'A treatment plan is created with detailed examination, hormone tests and ultrasound.',
  process_step2_title: 'Ovarian Stimulation',
  process_step2_desc: 'Ovaries are stimulated with hormone medications and egg development is monitored.',
  process_step3_title: 'Egg Retrieval',
  process_step3_desc: 'Mature eggs are collected under light anesthesia.',
  process_step4_title: 'Fertilization',
  process_step4_desc: 'Egg and sperm cells are combined in a laboratory environment.',
  process_step5_title: 'Embryo Development',
  process_step5_desc: 'The formed embryos are developed in the laboratory for 3-5 days.',
  process_step6_title: 'Embryo Transfer',
  process_step6_desc: 'The highest quality embryo is placed inside the uterus and a pregnancy test is awaited.',

  // Turkey Explore section
  explore_badge: 'Discover Turkey',
  explore_title: 'Get to Know',
  explore_title_highlight: 'Turkey',
  explore_subtitle: 'Don\'t miss the opportunity to explore this beautiful country while coming to Turkey for your treatment.',
  explore_destinations: 'Destinations',
  explore_culture: 'Culture & Life',
  explore_about_title: 'About Turkey',
  explore_about_subtitle: 'Cities, Destinations & Practical Info',
  explore_about_desc: 'Istanbul\'s historic peninsula, Izmir\'s Aegean coast, Antalya\'s turquoise waters and more. Discover Turkey\'s most beautiful destinations.',
  explore_about_highlights: 'Istanbul,Izmir,Antalya,Cappadocia',
  explore_culture_title: 'Culture in Turkey',
  explore_culture_subtitle: 'Etiquette, Cuisine & Traditions',
  explore_culture_desc: 'Turkish hospitality, tea culture, delicious cuisine and rich traditions. Everything you need to know before coming to Turkey.',
  explore_culture_highlights: 'Turkish Cuisine,Etiquette,Traditions,Social Life',
  explore_cta: 'Explore',
  explore_stat1: '81 Provinces, Countless Destinations',
  explore_stat2: 'Rich Turkish Cuisine',
  explore_stat3: '10,000 Years of History',

  // FAQ section
  faq_badge: 'Knowledge Library',
  faq_title: 'Frequently Asked',
  faq_title_highlight: 'Questions',
  faq_subtitle: 'Curious questions about the IVF process',
  faq_q1: 'What is IVF treatment and how does it work?',
  faq_a1: 'IVF (In Vitro Fertilization) is the process of combining egg and sperm cells in a laboratory environment and placing the resulting embryo into the mother\'s uterus. The treatment process consists of hormone therapy, egg retrieval, fertilization and embryo transfer stages.',
  faq_q2: 'How long does IVF treatment take?',
  faq_a2: 'One IVF treatment cycle takes an average of 4-6 weeks. This period covers the preparation, hormone therapy, egg retrieval and embryo transfer stages. However, the duration may vary as each patient\'s situation is different.',
  faq_q3: 'What is the success rate of IVF treatment?',
  faq_a3: 'The success rate depends on factors such as age, egg quality, sperm quality and general health. The success rate is around 40-50% for women under 35, and decreases with age. The chance of success increases in experienced centers and under appropriate conditions.',
  faq_q4: 'Is IVF treatment painful?',
  faq_a4: 'Most of the treatment process is painless. The egg retrieval procedure is performed under light anesthesia and discomfort is minimal. Embryo transfer is a painless procedure. Slight discomfort may be felt during hormone injections.',
  faq_q5: 'Is there an age limit for IVF treatment?',
  faq_a5: 'In Turkey, the legal age limit for IVF treatment is 18-49 for women and 18-60 for men. However, since the success rate decreases with age, it is more advantageous to start treatment especially under the age of 35.',
  faq_q6: 'What is the cost of IVF treatment?',
  faq_a6: 'The cost varies depending on the chosen center, treatment protocol and medication use. In Turkey, it ranges between 15,000-30,000 TL on average. Some private health insurances may provide partial coverage. You can contact institutions for detailed price information.',

  // Treatment services
  treat_sac_ekimi_title: 'Hair Transplant',
  treat_sac_ekimi_subtitle: 'FUE / DHI Technique',
  treat_sac_ekimi_desc: 'One of the most preferred health tourism services worldwide. Permanent and natural results.',
  treat_sac_ekimi_tag: 'Most Popular',
  treat_dis_tedavisi_title: 'Dental Treatment',
  treat_dis_tedavisi_subtitle: 'Implant / Veneer / Zirconia',
  treat_dis_tedavisi_desc: 'Turkey is Europe\'s most preferred destination for aesthetic dentistry and implant treatment.',
  treat_dis_tedavisi_tag: 'Highly Preferred',
  treat_goz_ameliyati_title: 'Eye Surgery',
  treat_goz_ameliyati_subtitle: 'LASIK / LASEK / Lens',
  treat_goz_ameliyati_desc: 'Permanent vision solutions with specialist clinics in laser eye surgery and intraocular lens applications.',
  treat_goz_ameliyati_tag: '',
  treat_estetik_cerrahi_title: 'Aesthetic Surgery',
  treat_estetik_cerrahi_subtitle: 'Rhinoplasty / Liposuction / BBL',
  treat_estetik_cerrahi_desc: 'Safe and quality operations with experienced specialists in plastic and aesthetic surgery.',
  treat_estetik_cerrahi_tag: 'High Demand',
  treat_ortopedi_title: 'Orthopaedics & Traumatology',
  treat_ortopedi_subtitle: 'Knee / Hip / Spine',
  treat_ortopedi_desc: 'Expert orthopaedic centres for joint replacement, spine surgery and sports injuries.',
  treat_ortopedi_tag: '',
  treat_tup_bebek_title: 'IVF Treatment',
  treat_tup_bebek_subtitle: 'IVF / ICSI / PGT',
  treat_tup_bebek_desc: 'Reach your dream of having a family with Turkey\'s accredited IVF centres in reproductive health.',
  treat_tup_bebek_tag: '',
  treat_kardiyoloji_title: 'Cardiology',
  treat_kardiyoloji_subtitle: 'Heart Surgery / Angiography',
  treat_kardiyoloji_desc: 'Cardiology centres offering world-class service in the treatment of cardiovascular diseases.',
  treat_kardiyoloji_tag: '',
  treat_onkoloji_title: 'Oncology',
  treat_onkoloji_subtitle: 'Cancer Treatment / Radiotherapy',
  treat_onkoloji_desc: 'A hopeful process with oncology centres using the most up-to-date methods in cancer diagnosis and treatment.',
  treat_onkoloji_tag: '',
  treat_obezite_title: 'Obesity Surgery',
  treat_obezite_subtitle: 'Gastric Sleeve / Bypass',
  treat_obezite_desc: 'Take a step towards a healthy life with specialist teams in obesity and metabolic surgery.',
  treat_obezite_tag: '',
  treat_checkup_title: 'Check-up & Screening',
  treat_checkup_subtitle: 'Comprehensive Health Screening',
  treat_checkup_desc: 'Protect your health with early diagnosis and comprehensive health screening packages.',
  treat_checkup_tag: '',
  treat_noroloji_title: 'Neurology & Brain Surgery',
  treat_noroloji_subtitle: 'Brain / Nervous System',
  treat_noroloji_desc: 'Comprehensive treatment with specialist centres in neurological diseases and brain surgery.',
  treat_noroloji_tag: '',
  treat_uroloji_title: 'Urology',
  treat_uroloji_subtitle: 'Kidney / Bladder / Prostate',
  treat_uroloji_desc: 'Safe solutions with specialist clinics in the diagnosis and treatment of urological diseases.',
  treat_uroloji_tag: '',
  treat_dermatoloji_title: 'Dermatology',
  treat_dermatoloji_subtitle: 'Skin / Laser / Aesthetic',
  treat_dermatoloji_desc: 'Healthy skin with specialist clinics in skin diseases and aesthetic dermatology.',
  treat_dermatoloji_tag: '',
  treat_fizik_tedavi_title: 'Physical Therapy',
  treat_fizik_tedavi_subtitle: 'Rehabilitation / Physiotherapy',
  treat_fizik_tedavi_desc: 'Fast recovery with specialist centres in physical therapy and rehabilitation.',
  treat_fizik_tedavi_tag: '',
  treat_organ_nakli_title: 'Organ Transplant',
  treat_organ_nakli_subtitle: 'Kidney / Liver / Heart',
  treat_organ_nakli_desc: 'A new life with experienced transplantation centres in organ transplantation.',
  treat_organ_nakli_tag: '',

  // CTA
  cta_badge: 'For Institutions',
  cta_title: 'Add Your Health Institution',
  cta_title_highlight: 'to the Platform',
  cta_subtitle: 'Reach more patients. Promote your institution with free or Pro membership, receive consultation requests and strengthen your online presence.',
  cta_register: 'Create Institution Account',
  cta_more_info: 'More Information',
  cta_stat_centers: 'Registered Centers',
  cta_stat_consultations: 'Consultation Requests',
  cta_stat_completed: 'Completed Consultations',
  cta_stat_cities: 'Cities',
};

export default home;
